import type { InstantSelector, VerseDef } from "./types";

/** Visual drop feedback while dragging a card. */
export type DragAimMode = "slot" | "layer" | "global";

/**
 * What part of the board should light up for this verse while dragging.
 * - slot: single-target lies / exact placeables
 * - layer: chips, still-layer, layer-prefer place
 * - global: auto selectors / self (drop anywhere)
 */
export function dragAimMode(def: VerseDef): DragAimMode {
  if (def.kind === "placeable") {
    // Always slot-aim: legal wash is per-cell, and resolvePlaceable honors the
    // aimed slot (layerPrefer/layerOnly used to ignore it and center-pick).
    return "slot";
  }

  const sel: InstantSelector = def.selector ?? "strongestLie";
  if (sel === "self" || sel === "empower") return "global";
  if (
    sel === "layerChip" ||
    sel === "layerSlam" ||
    sel === "slowLayer"
  ) {
    return "layer";
  }
  if (
    sel === "strongestLie" ||
    sel === "innermostLie" ||
    sel === "typePriority"
  ) {
    return "global";
  }
  // convertLie, slowLie, restorePrayer, exact aim
  if (def.respectMask === "autoOnly") return "global";
  if (def.respectMask === "layerOnly" || def.respectMask === "layerPrefer") {
    return "layer";
  }
  return "slot";
}
